import PraguePlugin from './plugin/PraguePlugin';
import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import { createLazyComponent, LazyModule, LazyImport } from 'owa-bundling';

export { default as isValidPragueURL } from './utils/isValidPragueURL';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "Prague" */ './lazyIndex'));

export type LazyPraguePlugin = LazyPlugin<PraguePlugin>;

export let LazyPraguePluginClass = createLazyPlugin(
    lazyModule,
    m => m.PraguePlugin,
    'Prague',
    null
);

export const PragueLoaderComponent = createLazyComponent(lazyModule, m => m.PragueLoaderComponent);
export let lazyFetchFileProviderAuthToken = new LazyImport(
    lazyModule,
    m => m.fetchFileProviderAuthToken
);

// Types
export { LazyPlugin };
